export default __webpack_public_path__ + "static/media/logo3x.6b6e3f53.png";